import { createAction, props } from '@ngrx/store';
import { ApiError } from '@hrra/core';
import { ActionPayload } from "@hrra/core";
import { Specialization } from '@hrra/common-models';

export enum Actions {
    GetJobseekerSpecializationList = '[Jobseeker profile] Get jobseeker specialization list',
    GetJobseekerSpecializationListSuccess = '[Jobseeker profile] Get jobseeker specialization list success',
    GetJobseekerSpecializationListFail = '[Jobseeker profile] Get jobseeker specialization list fail',
}

export const getJobseekerSpecializationList = createAction(
    Actions.GetJobseekerSpecializationList
);

export const getJobseekerSpecializationListSuccess = createAction(
    Actions.GetJobseekerSpecializationListSuccess,
    props<ActionPayload<Specialization[]>>()
);

export const getJobseekerSpecializationListFail = createAction(
    Actions.GetJobseekerSpecializationListFail,
    props<ActionPayload<ApiError>>()
); 